import { ZodType, z } from 'zod';

export type LogoutResponse = {
	message: string;
};

export const logoutResponseSchema: ZodType<LogoutResponse> = z.object({
	message: z.string(),
});
